import type MP4Box from 'mp4box';
import { TrackEventProp } from '@studio/constants/tracking-constants';
import type { AddError, VideoUploadTrackEventProperties } from '../../types/upload-video';
import { VALIDATIONS } from '../../types/upload-video';

const validateMaxResolution = (
  allow4k: boolean,
  info: MP4Box.Mp4BoxInfo,
  addError: AddError,
  trackEventProperties: VideoUploadTrackEventProperties
): { resolutionHeight: number; resolutionWidth: number } => {
  if (info.videoTracks.length) {
    const [videoTrack] = info.videoTracks;

    console.log(`Resolution: ${videoTrack.track_width} x ${videoTrack.track_height}`);

    trackEventProperties[TrackEventProp.VIDEO_UPLOAD_RESOLUTION_WIDTH] = videoTrack.track_width;
    trackEventProperties[TrackEventProp.VIDEO_UPLOAD_RESOLUTION_HEIGHT] = videoTrack.track_height;

    if (!allow4k && videoTrack.track_height > 1080) {
      addError(VALIDATIONS.MAX_RESOLUTION);
    }

    if (allow4k && videoTrack.track_height > 2160) {
      addError(VALIDATIONS.MAX_RESOLUTION_4K);
    }

    return {
      resolutionHeight: videoTrack.track_height,
      resolutionWidth: videoTrack.track_width,
    };
  }
  return {
    resolutionHeight: 0,
    resolutionWidth: 0,
  };
};

export default validateMaxResolution;
